const quizsPath="/";
const addQuiz="/addQuiz";
export const isQuizSelected=(currentPath)=>currentPath ===quizsPath;
export const isaddQuizSelected=(currentPath)=>currentPath ===addQuiz;
